import React, { Fragment, type SVGAttributes } from 'react';

import * as iconMap from './map';

export type TIconName = keyof typeof iconMap;

function isIconMapKey(key: string): key is keyof typeof iconMap {
  return key in iconMap;
}

type TProps = {
  name: TIconName;
} & SVGAttributes<SVGSVGElement>;

export const Icon = React.forwardRef<SVGSVGElement, TProps>(
  ({ name, ...rest }, ref) => {
    const IconComponent = isIconMapKey(name) ? iconMap[name] : Fragment;

    return <IconComponent ref={ref} {...rest} />;
  }
);
